import Link, { LinkProps } from 'next/link'
import React from 'react'

import { NavigationItemLink as UINavigationItemLink, BaseNavigationItemLinkProps } from '~shared/ui/SidebarNavigation'

type NavigationItemLinkProps = BaseNavigationItemLinkProps &
  Prefer<LinkProps, React.AnchorHTMLAttributes<HTMLAnchorElement>>

function NavigationItemLink({ children, ...props }: NavigationItemLinkProps) {
  return (
    <UINavigationItemLink<LinkProps> component={Link} {...props}>
      {children}
    </UINavigationItemLink>
  )
}

export default NavigationItemLink
